import { PropertyDetailInventoriesList } from '@/components/organism';
import { navigateTo, Paths } from '@/router';
import type { InventoryInspectionOutput } from '@/types/custom-types';

const PageContent = () => {
  const handleCreate = (propertyId: string) => {
    navigateTo(`${Paths.INVENTORY}${Paths.FORM}?propertyId=${propertyId}`);
  };

  const handleEdit = (propertyId: string, inventory: InventoryInspectionOutput) => {
    navigateTo(`${Paths.INVENTORY}${Paths.FORM}?propertyId=${propertyId}&inspectionId=${inventory.id}`);
  };

  const handleDetails = (propertyId: string, inventory: InventoryInspectionOutput) => {
    navigateTo(`${Paths.INVENTORY}${Paths.FORM}?propertyId=${propertyId}&inspectionId=${inventory.id}&readonly=true`);
  };

  return (
    <PropertyDetailInventoriesList
      onCreate={handleCreate}
      onEdit={handleEdit}
      onDetails={handleDetails}
    />
  );
};

export const InventoryListPage = () => {
  return <PageContent />;
};
